<template>
    <div class="client-space">
<!--        <a href="http://www.atom-training.com/?utm_source=cat-uxo" target="_blank">-->
<!--            <img :src="randomImage" alt="Advert"/>-->
<!--        </a>-->
    </div>
</template>

<script>
    export default {
        name: "CatUxoAdvert",
        data: function () {
            return {
                adverts: [
                    'frmServices_TopImage_AnalysingTrainingRequirements@3x.png',
                    'frmServices_TopImage_BorderSecurity@3x.png',
                    'frmServices_TopImage_CIEDTraining@3x.png',
                    'frmServices_TopImage_CMDTraining@3x.png',
                    'frmServices_TopImage_Commercial@3x.png',
                    'frmServices_TopImage_CurriculumDevelopment@3x.png',
                    'frmServices_TopImage_EquipmentTraining@3x.png',
                    'frmServices_TopImage_EvaluatingTrainingEffectiveness@3x.png',
                    'frmServices_TopImage_ExercisesPlanning@3x.png',
                    'frmServices_TopImage_ExplosiveTraining@3x.png',
                    'frmServices_TopImage_Maritime@3x.png',
                    'frmServices_TopImage_Military@3x.png',
                    'frmServices_TopImage_MissionSupportKits@3x.png',
                    'frmServices_TopImage_PoliceandFirstResponders@3x.png',
                    'frmServices_TopImage_SearchTraining@3x.png',
                    'frmServices_TopImage_SpecialistTools@3x.png',
                    'frmServices_TopImage_TrainingAids@3x.png',
                    'frmServices_TopImage_TransportationVunerabilities@3x.png',
                ]
            }
        },
        computed: {
          randomImage() {
              let index = Math.floor((Math.random() * 16) + 1);
              return  '/img/adverts/' + this.adverts[index];
          }
        },
        mounted() {
        }
    }
</script>

<style lang="scss" scoped>
    .client-space img {
        border-radius: $border-radius;
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/Advert.vue